import { LinkProps, Link, NavLink, NavLinkProps } from 'react-router-dom';

interface LinkOrPortedProps extends LinkProps, Omit<NavLinkProps, 'activeClassName' | 'activeStyle'> {
  dataDurableId?: string;
  type?: 'navlink';
}

export default function LinkOrPorted({ type, to, dataDurableId, children, ...rest }: LinkOrPortedProps) {
  // this adds support for external links, this is needed for our progressive cut over!
  const isExternal = typeof to === 'string' && to.includes('http');

  if (isExternal)
    return (
      <a
        data-dd-privacy="allow"
        data-durable-id={dataDurableId}
        data-intercom-target={dataDurableId || rest['data-durable-id']}
        {...rest}
        href={to}
      >
        {children}
      </a>
    );
  if (type === 'navlink') {
    return (
      <NavLink
        data-dd-privacy="allow"
        data-durable-id={dataDurableId}
        data-intercom-target={dataDurableId || rest['data-durable-id']}
        {...rest}
        to={to}
      >
        {children}
      </NavLink>
    );
  }
  return (
    <Link
      data-dd-privacy="allow"
      data-durable-id={dataDurableId}
      data-intercom-target={dataDurableId || rest['data-durable-id']}
      {...rest}
      to={to}
    >
      {children}
    </Link>
  );
}
